<template>
  <div id="modemASRequestPopup">
    <div class="common_view_tit">요청모뎀 정보</div>
    <div class="common_view_list">
      <div class="common_view_item">
        <div>
          <div>본부</div>
          <div>
            <template v-if="selectedItem.affiliateCode != null">
              <template v-for="afc in afcList" v-if="afc.codeValue === selectedItem.affiliateCode">{{afc.codeName}}</template>
            </template>
            <template v-if="selectedItem.officeCode != null">
              <template v-for="ofc1 in ofc1List" v-if="ofc1.codeValue === (selectedItem.officeCode.length === 5 ? selectedItem.officeCode : selectedItem.officeCode.substring(0, 5))">{{ofc1.codeName}}</template>
              <template v-if="selectedItem.officeCode.length > 5">
                <template v-for="ofc2 in ofc2List" v-if="ofc2.codeValue === selectedItem.officeCode">{{ofc2.codeName}}</template>
              </template>
            </template>
            <template v-if="selectedItem.affiliateCode == null && selectedItem.officeCode == null">-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>사업구분</div>
          <div>
            <template v-if="selectedItem.projectType != null">
              <template v-for="prt in prtList" v-if="prt.codeValue === selectedItem.projectType">{{prt.codeName}}</template>
            </template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>이동전화번호</div>
          <div>
            <template v-if="selectedItem.mobilePhone != null">{{selectedItem.mobilePhone}}</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
    </div>
    <div class="common_view_tit">처리사항 등록/수정</div>
    <div class="common_textarea_wrap">
      <template v-if="popupParams.type === 'P'">
        <textarea v-model="asDesc"></textarea>
        <div>*최대 256자까지 입력이 가능합니다.</div>
      </template>
      <span v-else>{{asDesc}}</span>
    </div>
    <div class="common_bottom_wrap padding_wrap">
      <div class="btn_bottom btn_close" @click="hidePopup">닫기</div>
      <div class="btn_bottom btn_blue_t" @click="saveAsDesc" v-if="popupParams.type === 'P'">등록(선택)</div>
    </div>
  </div>
</template>

<script>
import common from '../../script/common'
import modemAS from '../../script/modemAS'
import {defaultLoadingOptions} from '../../script/defaultConfig'

export default {
  props: ['popupParams'],
  data () {
    return {
      // Common Data
      mySession: {},
      afcList: [],
      ofcList: [],
      ofc1List: [],
      ofc2List: [],
      prtList: [],
      // Data
      selectedItem: {},
      asDesc: ''
    }
  },
  mounted () {
    this.selectedItem = this.popupParams.data
    if (this.selectedItem != null && this.selectedItem.asDesc != null) {
      this.asDesc = this.selectedItem.asDesc
    }
    common.getSession(response => {
      if (response.data.resultCode === 1 && response.data.result != null && response.data.result.userPid != null && response.data.result.userRole != null) {
        this.mySession = response.data.result
        let intervalCnt = 0
        let interval = setInterval(() => {
          if (common.checkValidateData('session', sessionStorage.getItem('afcList')) &&
            common.checkValidateData('session', sessionStorage.getItem('ofcList')) &&
            common.checkValidateData('session', sessionStorage.getItem('prtList'))) {
            clearInterval(interval)
            this.afcList = JSON.parse(sessionStorage.getItem('afcList'))
            this.ofcList = JSON.parse(sessionStorage.getItem('ofcList'))
            this.ofc1List = this.getOfc1List()
            if (this.selectedItem.officeCode != null && this.selectedItem.officeCode.length > 5) {
              this.getOfc2List()
            }
            this.prtList = JSON.parse(sessionStorage.getItem('prtList'))
          } else if (intervalCnt > 10) {
            clearInterval(interval)
            common.amsAlert('retry', '필수 데이터를 불러오지 못했습니다.')
          } else {
            intervalCnt++
          }
        }, 200)
      } else {
        common.amsAlert('general', '로그아웃 되었습니다.\n다시 로그인해주세요.')
        this.$router.replace('/Login')
      }
    })
  },
  watch: {
    popupParams () {
      this.selectedItem = this.popupParams.data
    }
  },
  methods: {
    hidePopup (args) {
      this.$emit('hidePopup', args)
    },
    getOfc1List () {
      return this.ofcList.filter(item => { return item.codeLevel === 0 })
    },
    getOfc2List () {
      this.ofc2List = this.ofcList.filter(item => { return item.codeParent === this.selectedItem.officeCode.substring(0, 5) })
    },
    saveAsDesc () {
      if ((this.mySession.subRole & 2) === 0) {
        common.amsAlert('general', '권한이 없습니다.')
        return
      }
      const result = common.checkUserRole(this.mySession, 4, 'add')
      if (!result.code) {
        return
      }
      let vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
      modemAS.modemAS('post', {
        asPid: this.selectedItem.asPid,
        asDesc: this.asDesc
      }, response => {
        console.log('모뎀 A/S 처리사항 등록/수정', response)
        vueLoadingOverlay.hide()
        if (response.data.resultCode === 1) {
          common.amsAlert('general', '처리사항을 저장했습니다.')
          this.hidePopup({type: 'L'})
        } else {
          common.amsAlert('retry', '처리사항을 저장하지 못했습니다.')
        }
      })
    }
  }
}
</script>

<style scoped>
#modemASRequestPopup .common_bottom_wrap > .btn_bottom {
  height: 46px;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 46px;
}

#modemASRequestPopup .common_bottom_wrap > .btn_close {
  width: 76px;
  margin: auto auto auto 0;
  color: #36414F;
}
</style>



// WEBPACK FOOTER //
// src/components/modemAS/ModemASProgressPopup.vue